
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import { AppUser } from "@/script/apps/user/entity/UserEntity";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { DictUtil } from "@/script/core/Dict";
import { AppUserService } from "@/script/apps/user/service/AppUserService";
import { ElMessage, ElNotification } from "element-plus";
import { UserService } from "@/script/apps/system/service/UserService";

@Options({})
export default class AppUserDetail extends BaseDetail {
  private service = new AppUserService();

  private dialogVisible = false;

  private discountRules = {
    large: [{ required: true, message: "请选择是否大客户", trigger: "change" }],
    discount: [
      { required: true, message: "请输入大客户折扣", trigger: "blur" },
    ],
  };

  public initData(): ServiceContext {
    return ServiceFactory.build(
      "biz_user",
      "/user/appuser",
      "/user/appuser",
      this.service
    );
  }

  public newEntity() {
    const entity: AppUser = {};
    return entity;
  }

  openLargeDiscount() {
    this.dialogVisible = true;
  }

  changeLargeDiscount() {
    const self = this;
    const user: AppUser = this.entity;
    (this.$refs.formDiscount as any).validate((valid: boolean) => {
      if (valid) {
        self.service.setLargeDiscount(
          user,
          function (result: any) {
            ElNotification({
              type: "success",
              title: "设置大客户折",
              message: "设置大客户折扣成功",
            });
            self.dialogVisible = false;
          },
          function (error: Error) {
            ElMessage.error("设置大客户折扣失败，原因：" + error.message);
          }
        );
      } else {
        return false;
      }
    });
  }
}
